// extracted by mini-css-extract-plugin
module.exports = {"cards":"ccfda6eb9f--cards--Hs0AJ","card":"ccfda6eb9f--card--Jzeeb","card-title":"ccfda6eb9f--card-title--jQ33a","card-paragraph":"ccfda6eb9f--card-paragraph--ykfKK"};